// Translations
import landing from '../views/landing/translations/en'

// Translation: Password change (English)
export default Object.freeze({
	name: 'Password change',
	views: { landing }
})
